import {SVGLoader} from "three/addons/loaders/SVGLoader.js";
import * as THREE from "three";
import {RGBtoHex,hexToRGB, setOnTheMiddle} from "./helpFunctionsFile";
import {gsap} from "gsap";
import store from "../../store/index.js";
import {useSnapshot} from "valtio";
import state from "../../store/index.js";
import {getThemeContext} from "../../providers/ThemeProvider.jsx";

const extrudeSettings = {
    // steps: 2,
    depth: 2322,
    color: ""
};


var material1;
var material2;

const factorScala = 0.8;
const renderSVG = (extrusion, svgURL) => {

    extrudeSettings.depth = extrusion
    // extrudeSettings.color = state.color

    const loader = new SVGLoader();
    const svgGroup = new THREE.Group();
    var updateMap = [];


    material1  = new THREE.MeshPhongMaterial( {
        color: "blue",
        emissive: 'black',
        shininess: 0.2
    } );


    material2  = new THREE.MeshPhongMaterial( {
        color: "green",
        emissive: 'black',
        shininess: 0.2
    } );


    // console.log("theeeeme", themeContext)

    loader.load(
        svgURL,
        function (svgData){
            const fractionSize = window.innerWidth / 1000; // Ajusta según tus necesidades
            svgGroup?.scale.set(fractionSize * factorScala, -fractionSize * factorScala, fractionSize * factorScala );
            // setOnTheMiddle(svgGroup)


            // svgGroup.scale.z *= fractionSize;
            svgData.paths.forEach((path) => {
                const shapes = SVGLoader.createShapes(path);
                // console.log("path", path)

                shapes.forEach((shape) => {
                    const meshGeometry = new THREE.ExtrudeGeometry(shape, {
                        depth: extrudeSettings.depth,
                        bevelEnabled: false,
                    });
                    //Seleccion del color de cada camino del SVG.
                    var color_r = parseInt(path.color.r * 255)
                    var color_g = parseInt(path.color.g * 255)
                    var color_b = parseInt(path.color.b * 255)
                    var color_aux = RGBtoHex(color_r, color_g, color_b);
                    // var color_aux = "green";
                    // console.log("pasannaaa", state.color)
                    const material = new THREE.MeshPhongMaterial( {
                        // color: state.color,
                        color: color_aux,
                        emissive: 'black',
                        shininess: 49,
                        name: "materialillo"
                    } );

                    const stokeMaterial = new THREE.LineBasicMaterial({
                        color: "#00A5E6",
                    });
                    const linesGeometry = new THREE.EdgesGeometry(meshGeometry);
                    const mesh = new THREE.Mesh(meshGeometry, material);
                    // const lines = new THREE.LineSegments(linesGeometry, stokeMaterial);

                    mesh.name = path.userData.node.getAttribute("id")
                    updateMap.push({ shape, mesh });
                    // console.log(updateMap)
                    svgGroup.add(mesh);
                });

                // console.log("svgGroup", svgGroup)
                // console.log("path", path)

            });



            //Centramos el SVG
            setOnTheMiddle(svgGroup)

            // svgGroup.position.z = -104300;


        });


    // svgGroup.rotateX(-Math.PI / 2);

    return {
        object: svgGroup,
        update(extrusion, theme, renderer, scene, camera) {


                // 1. Ajusta la profundidad de extrusión
                extrudeSettings.depth = extrusion;

                // 2. Recorre tus objetos guardados en updateMap
                updateMap?.forEach((item) => {
                    // B. Crea la nueva geometría
                    const newGeometry = new THREE.ExtrudeGeometry(
                        item.shape,
                        extrudeSettings,

                    );
                    // newGeometry.name = item.mesh.name

                    // C. Libera la geometría previa y reasigna la nueva
                    item.mesh.geometry.dispose();
                    item.mesh.geometry = newGeometry;
                });



        },
        updateColor(newColor, theme, scene){
            // console.log("updateando color", newColor)

            setTimeout(() => {
                // console.log("aaaaaaaa", updateMap)
                // console.log("scene", scene)
                    scene?.traverse((item) => {

                        if (typeof item === "Scene")
                            return;
                        var newColorObj ;
                        // console.log("item", item)
                        switch (item.name) {
                            case "letra_3":
                            case "letra_d":
                                if (theme === "light") {
                                    newColorObj = new THREE.Color("#be2128");
                                }else if (theme === "dark"){
                                    newColorObj = new THREE.Color("#be2128");
                                }
                                newColorObj = new THREE.Color("red");
                                break;
                            default:
                                if (theme === "light") {
                                    newColorObj = new THREE.Color("gray");
                                }else if (theme === "dark"){
                                    newColorObj = new THREE.Color("white");
                                }
                                break;
                        }
                        if (item.material != null || item.material != undefined){
                            item.material.color.set(newColorObj);
                            item.material.needsUpdate = true;
                        }
                    });
                    }, 10);


        },
        showOrHide( scene,  show){
            // console.log("show", show)

            // scene.traverse ( function (child) {
            //     if (child instanceof THREE.Mesh) {
            //         // child.visible = show;
            //     }
            // });
        },
        changeSizeww(scene, fractionSize, axisrotate = true) {
            // Obtener el objeto que queremos escalar (por ejemplo, el grupo de letras)
            const targetObject = scene.children[1];

            if (!targetObject) {
                console.warn("No se encontró el objeto objetivo para escalar.");
                return;
            }

            // Calcular los límites del grupo de letras
            const boundingBox = new THREE.Box3().setFromObject(targetObject);
            console.log("BoundingBox del objeto:", boundingBox);

            // Calcular el tamaño del objeto en el espacio 3D
            const size = new THREE.Vector3();
            boundingBox.getSize(size);
            console.log("Tamaño actual del objeto:", size);

            // Calcular el centro del objeto
            const center = new THREE.Vector3();
            boundingBox.getCenter(center);
            console.log("Centro del objeto:", center);

            // Ajustar el tamaño del objeto según el fracción proporcionada
            const scale = fractionSize;
            if (axisrotate){
                targetObject.scale.set(scale, -scale, scale);
            }else {
                targetObject.scale.set(scale, scale, scale);
            }

            // Después de escalar, reubicar el objeto para mantenerlo centrado en la escena
            const newBoundingBox = new THREE.Box3().setFromObject(targetObject);


            // Crear un BoxHelper para visualizar el BoundingBox
            // const boxHelper = new THREE.BoxHelper(targetObject, 0xff0000); // Color rojo prominente
            // scene.add(boxHelper);


            const newSize = new THREE.Vector3();
            newBoundingBox.getSize(newSize);
            const offset = center.clone().sub(newBoundingBox.getCenter(new THREE.Vector3()));

            // targetObject.position.add(offset);

            console.log("Nuevo tamaño del objeto:", newSize);
            console.log("Nueva posición del objeto:", targetObject.position);

            // Actualizar la escena para reflejar los cambios
            scene.updateMatrixWorld(true);
        },
        setOnTheMiddle(group){
            const box = new THREE.Box3().setFromObject(group);
            const size = box.getSize(new THREE.Vector3());
            const yOffset = size.y / -2;
            const xOffset = size.x / -2;

            // Offset all of group's elements, to center them
            group.children.forEach((item) => {
                item.position.x = xOffset;
                item.position.y = yOffset;
            });
        },
        changeSize(scene, fractionSize, axisRotate = true, initial = true) {
            // Obtener el objeto que queremos escalar
            const targetObject = scene.children[1]; // Asegúrate de que este índice sea correcto

            setOnTheMiddle(targetObject)
            if (!targetObject) {
                console.warn("No se encontró el objeto objetivo para escalar.");
                return;
            }

            if(!initial){
                // Calcular los límites actuales del objeto
                const boundingBox = new THREE.Box3().setFromObject(targetObject);
                console.log("BoundingBox inicial del objeto:", boundingBox);

                // Calcular el centro actual del objeto
                const center = new THREE.Vector3();
                boundingBox.getCenter(center);
                console.log("Centro inicial del objeto:", center);
            }


            // Ajustar el tamaño del objeto según la fracción proporcionada
            var scale = fractionSize;
            scale = scale * factorScala;
            console.log("Escala:", scale);
            if (axisRotate) {
                targetObject.scale.set(scale, -scale, scale); // Invertir eje Y si es necesario
            } else {
                targetObject.scale.set(scale, scale, scale);
            }



            // Actualizar la escena para reflejar los cambios
            scene.updateMatrixWorld(true);
        },
        fitCameraToCenteredObject(camera, object) {
            const boundingBox = new THREE.Box3();

            boundingBox.setFromObject(object);

            const center = boundingBox.getCenter(new THREE.Vector3());
            console.log("cenetttte",center);
            object.position.sub(center);
        }





    };
};


export {renderSVG}